import { useMissions } from "@rescuetablet/missions-client/react";
import { useMemo } from "react";
import { Outlet } from "react-router";

export default function MissionsProvider() {
  const missions = useMissions();
  // FIXME sort missions
  const sorted = useMemo(() => Object.values(missions), [missions]);

  return <Outlet context={{ missions: sorted }} />;
}
